export const EMPTY_USER_IMAGE_NAME = 'user-empty-state.svg'
